import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { environment } from 'src/environments/environment';
import { BrokerService } from '../core/broker/broker.service';
import { DiaryDocDetail } from '../models/diaryDocDetails.Model';
import { UploadedDiariesModel } from '../models/uploadedDiaries.Model';

@Injectable({
  providedIn: 'root',
})
export class OnboardingService {
  constructor(private _http: HttpClient, private _broker: BrokerService) {}

  private get brokerId(): string {
    return this._broker.brokerId();
  }

  getCustomHeader(): HttpHeaders {
    const customHeaders = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set(
        'Ocp-Apim-Subscription-Key',
        environment.apiManagement.subscriptionKey
      );

    return customHeaders;
  }

  listUploadedDiaries(): Observable<UploadedDiariesModel[]> {
    return this._http.get<UploadedDiariesModel[]>(
      `${environment.apiManagement.address}api/Documents/GetUploadedDiaries?brokerId=${this.brokerId}`,
      { headers: this.getCustomHeader() }
    );
  }

  getDiaryByPolicyCode(policyCode: string): Observable<any> {
    return this._http.get(
      `${environment.apiManagement.address}api/Documents/GetUploadedDiaries?brokerId=${this.brokerId}`,
      { headers: this.getCustomHeader() }
    );
  }

  getFile(docDetail: DiaryDocDetail): Observable<Blob> {
    return this._http.post(
      `${environment.apiManagement.address}api/Documents/GetFile`,
      { ...docDetail, BrokerID: this.brokerId },
      { responseType: 'blob', headers: this.getCustomHeader() }
    );
  }

  getNBPack(policyCode: string, fromArchived = false): Observable<Blob> {
    return this._http.get(
      `${environment.apiManagement.address}api/Documents/GetAllDocumentsPDF?policyCode=${policyCode}&brokerId=${this.brokerId}&fromArchived=${fromArchived}`,
      { responseType: 'blob', headers: this.getCustomHeader() }
    );
  }

  saveAssignedTask(tasks: UploadedDiariesModel[]): Observable<any> {
    return this._http.post(
      `${environment.apiManagement.address}api/Workflow/SaveUploadedDiariesAssigned`,
      tasks.map((task) => ({ ...task, BrokerID: this.brokerId })),
      { headers: this.getCustomHeader() }
    );
  }
}
